import { useEffect } from 'react'
import { X, FileText } from 'lucide-react'

/**
 * RegulamentoModal - Shows a "Regulamento" button and handles:
 *   - tipo="texto": opens a modal with HTML content
 *   - tipo="pdf": opens the PDF URL in a new tab
 */
export default function RegulamentoModal({ regulamento, corPrimaria, show, onToggle }) {
  if (!regulamento) return null

  const handleClick = () => {
    if (regulamento.tipo === 'pdf' && regulamento.arquivo_url) {
      window.open(regulamento.arquivo_url, '_blank')
    } else {
      onToggle()
    }
  }

  return (
    <>
      {/* Regulamento Button */}
      <button
        onClick={handleClick}
        className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium text-sm transition-opacity hover:opacity-90 border border-white/30"
        style={{ backgroundColor: corPrimaria }}
      >
        <FileText className="w-4 h-4" />
        Regulamento
      </button>

      {/* Modal (only for texto type) */}
      {regulamento.tipo === 'texto' && show && (
        <ModalOverlay onClose={onToggle}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col mx-4">
            {/* Modal Header */}
            <div
              className="flex items-center justify-between px-6 py-4 rounded-t-xl"
              style={{ backgroundColor: corPrimaria }}
            >
              <h2 className="text-lg font-bold text-white">Regulamento</h2>
              <button
                onClick={onToggle}
                className="text-white/80 hover:text-white transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-y-auto p-6">
              <div
                className="prose prose-sm max-w-none text-gray-700"
                dangerouslySetInnerHTML={{ __html: regulamento.conteudo || '' }}
              />
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
              <button
                onClick={onToggle}
                className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                Fechar
              </button>
            </div>
          </div>
        </ModalOverlay>
      )}
    </>
  )
}

function ModalOverlay({ children, onClose }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      {children}
    </div>
  )
}
